import { render, staticRenderFns } from "./Cyclotorsion.vue?vue&type=template&id=2bd6169e&scoped=true&"
import script from "./Cyclotorsion.vue?vue&type=script&lang=js&"
export * from "./Cyclotorsion.vue?vue&type=script&lang=js&"
import style0 from "./Cyclotorsion.vue?vue&type=style&index=0&id=2bd6169e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6169e",
  null
  
)

export default component.exports